import Vue from 'vue';
import Vuex, { MutationTree, ActionTree } from 'vuex';
import { Configuration } from '../../../models/configuration';
import { ProposalMatch } from '../../../models/proposalmatch';
import { Option } from '../../../models/option';
import { Photo } from '../../../models/photo';
import axios from 'axios';

Vue.use(Vuex);

interface State {
    configuration: Configuration;
    values: number[];
    proposalMatches: ProposalMatch[];
}

const mutations: MutationTree<State> = {
    setConfiguration: (currentState, configuration) => {
        currentState.configuration = configuration;
    },

    setValues: (currentState, values) => {
        currentState.values = values;
    },

    setProposalMatches: (currentState, values) => {
        currentState.proposalMatches = values;
    },

    addOption: (currentState, data) => {

        const newOption: Option = data.option;
        const topic_id = data.topic_id;

        let index = -1;

        // Find the index of the existing answer
        for (let i = 0; i < currentState.configuration.options.length; i++) {
            if (currentState.configuration.options[i].topic_id === topic_id) {
                index = i;
                break;
            }
        }

        newOption.topic_id = topic_id;

        if (index !== -1) {
            // It does already exist, replace this answer
            // state.configuration.options[index] = newOption
            Vue.set( currentState.configuration.options, index, newOption);

        } else {
            // state.configuration.options.push(newOption)
            Vue.set( currentState.configuration.options, currentState.configuration.options.length, newOption);
        }

        // Update the values for the graph
        // IMPORTANT: Be careful here, we expect that the Options are always
        // generated from a given seeder file with the same order
        const invertedValue = Math.abs(newOption.value - 4) + 1;
        currentState.values[newOption.topic_id - 1] = invertedValue;

        // a hack to make a change in state so the vue watchers notice the change !
        const tempValues = currentState.values;
        currentState.values = [];
        currentState.values = tempValues;
    },

    addLike(currentState: State, photo: Photo) {
        if (currentState.configuration.photos_liked.indexOf(photo) === -1) {
            currentState.configuration.photos_liked.push(photo);
        }  else {
            // When it already exist remove it
            currentState.configuration.photos_liked =
            currentState.configuration.photos_liked.filter(function(photoLiked) {
                return (photoLiked.id !== photo.id);
            });
        }
    },

    removeLike(currentState: State, photo: Photo) {
        currentState.configuration.photos_liked = currentState.configuration.photos_liked.filter(function(photoLiked) {
            return (photoLiked.id !== photo.id);
        });
    },

    addDislike(currentState: State, photo: Photo) {
        if (currentState.configuration.photos_disliked.indexOf(photo) === -1) {
            currentState.configuration.photos_disliked.push(photo);
        }  else {
            // When it alreay exist remove it
            currentState.configuration.photos_disliked =
            currentState.configuration.photos_disliked.filter(function(photoDisliked) {
                return (photoDisliked.id !== photo.id);
            });
        }
    },

    removeDislike(currentState: State, photo: Photo) {
        currentState.configuration.photos_disliked =
        currentState.configuration.photos_disliked.filter(function(photoDisliked) {
            return (photoDisliked.id !== photo.id);
        });
    },

    reset(currentState) {

        console.log('RESET the whole configuration object');

        currentState.configuration = {
            id: 0,
            name: 'New Configuration',
            when: new Date(),
            options: Array<Option>(),
            photos_liked: Array<Photo>(),
            photos_disliked: Array<Photo>(),
        };

        currentState.values = [0, 0, 0, 0, 0, 0, 0, 0];
    },
};

const actions: ActionTree < State, any > = {

};

const getters = {
    values(currentState: State): number[] {
        return currentState.values;
    },

    proposalMatches(currentState: State): ProposalMatch[] {
        return currentState.proposalMatches;
    },

    configuration(currentState: State): Configuration {
        return currentState.configuration;
    },

    selectedOptions(currentState: State): Option[] {
        return currentState.configuration.options;
    },

    photosLiked(currentState: State): Photo[] {
        return currentState.configuration.photos_liked;
    },

    photosDisliked(currentState: State): Photo[] {
        return currentState.configuration.photos_disliked;
    },

    isPhotoLiked: (currentState: State) => (photo: Photo) => {
        return currentState.configuration.photos_liked.filter((likedPhoto) => {
            return likedPhoto.id === photo.id;
        }).length === 1;
    },

    isPhotoDisliked: (currentState: State) => (photo: Photo) => {
        return currentState.configuration.photos_disliked.filter((dislikedPhoto) => {
            return dislikedPhoto.id === photo.id;
        }).length === 1;
    },

    amountOfLikes: (currentState: State) => (proposalMatch: ProposalMatch) => {
        return currentState.configuration.photos_liked.filter((likedPhoto) => {
            return likedPhoto.proposal_id === proposalMatch.proposal_id;
        }).length;
    },

    amountOfDislikes: (currentState: State) => (proposalMatch: ProposalMatch) => {
        return currentState.configuration.photos_disliked.filter((dislikedPhoto) => {
            return dislikedPhoto.proposal_id === proposalMatch.proposal_id;
        }).length;
    },
};

const state: State = {
    configuration: {
        id: 0,
        name: 'New Configuration',
        when: new Date(),
        options: Array<Option>(),
        photos_liked: Array<Photo>(),
        photos_disliked: Array<Photo>(),
    },

    values: [0, 0, 0, 0, 0, 0, 0, 0],

    proposalMatches : Array<ProposalMatch>(),
};

const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};

export default module;
